import { render, staticRenderFns } from "./Classic.vue?vue&type=template&id=4cb3fe58&scoped=true&"
import script from "./Classic.vue?vue&type=script&lang=js&"
export * from "./Classic.vue?vue&type=script&lang=js&"
import style0 from "./Classic.vue?vue&type=style&index=0&id=4cb3fe58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3fe58",
  null
  
)

export default component.exports